import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllOrdersAsync, resetOrderUpdateStatus, selectOrderUpdateStatus, selectOrders, updateOrderByIdAsync } from '../../order/OrderSlice'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Avatar, Button, Chip, FormControl, IconButton, InputLabel, MenuItem, Select, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { useForm } from "react-hook-form"
import { toast } from 'react-toastify';
import {noOrdersAnimation} from '../../../assets/index'
import Lottie from 'lottie-react'
import VisibilityIcon from "@mui/icons-material/Visibility";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const AdminOrders = () => {

  const dispatch=useDispatch()
  const orders=useSelector(selectOrders)
  const [editIndex,setEditIndex]=useState(-1)
  const orderUpdateStatus=useSelector(selectOrderUpdateStatus)
  const theme=useTheme()
  const is1620=useMediaQuery(theme.breakpoints.down(1620))
  const is1200=useMediaQuery(theme.breakpoints.down(1200))
  const is820=useMediaQuery(theme.breakpoints.down(820))
  const is480=useMediaQuery(theme.breakpoints.down(480))

  const {register,handleSubmit,formState: { errors },} = useForm()

  useEffect(()=>{
    dispatch(getAllOrdersAsync())
  },[dispatch])


  useEffect(()=>{
    if(orderUpdateStatus==='fulfilled'){
      toast.success("Status udpated")
      dispatch(getAllOrdersAsync())
    }
    else if(orderUpdateStatus==='rejected'){
      toast.error("Error updating order status")
    }
  },[orderUpdateStatus])

  useEffect(()=>{
    return ()=>{
      dispatch(resetOrderUpdateStatus())
    }
  },[])


  const handleUpdateOrder=(data)=>{
    const update={...data,_id:orders[editIndex]._id}
    setEditIndex(-1)
    dispatch(updateOrderByIdAsync(update))
  }


  const editOptions=['Pending','Dispatched','Out for delivery','Delivered','Cancelled']

  const getStatusColor=(status)=>{
    if(status==='Pending'){
      return {bgcolor:'#dfc9f7',color:'#7c59a4'}
    }
    else if(status==='Dispatched'){
      return {bgcolor:'#feed80',color:'#927b1e'}
    }
    else if(status==='Out for delivery'){
      return {bgcolor:'#AACCFF',color:'#4793AA'}
    }
    else if(status==='Delivered'){
      return {bgcolor:"#b3f5ca",color:"#548c6a"}
    }
    else if(status==='Cancelled'){
      return {bgcolor:"#fac0c0",color:'#cc6d72'}
    }
  }


  async function getColorName(hex) {
    if (!hex) return "---";

    try {
      const cleanHex = hex.replace("#", "");
      const res = await fetch(`https://www.thecolorapi.com/id?hex=${cleanHex}`);
      const data = await res.json();
      return data?.name?.value || "---";
    } catch {
      return "---";
    }
  }

  async function prepareTableBody(order) {
    return Promise.all(
      order.item.map(async (i) => {
        const colorName = i.color
          ? await getColorName(i.color)
          : "---";
  
        return [
          i.product.title,
          colorName,            // ✅ HEX → NAME
          i.size || "---",
          i.quantity,
          "Rs." + i.product.price,
          "Rs." + (i.product.price * i.quantity),
        ];
      })
    );
  }
  

  const viewInvoicePDF = async (order) => {
    const doc = new jsPDF();
  
    const today = new Date().toDateString();
    
    const addressList = Array.isArray(order.address)
      ? order.address
      : [order.address];

    const addr = addressList[0] || {};

    doc.setFontSize(18);
    doc.text("ORDER INVOICE", 14, 15);
    doc.setFontSize(11);
    doc.text(`Invoice Date: ${today}`, 150, 15, { align: "right" });
  
    doc.line(10, 20, 200, 20);
    
    doc.setFontSize(12);
  doc.text(`Order ID: ${order._id}`, 95, 30);
  // doc.text(`Invoice Date: ${today}`, 95, 37);
  doc.text(`Status: ${order.status}`, 95, 37);
  doc.text(`Payment: ${order.paymentMode}`, 95, 44);
  
    doc.setFontSize(14);
    doc.text("Customer Details", 14, 30);
  
    doc.setFontSize(11);
    doc.text(`Name: ${order.users.name}`, 14, 38);
    doc.text(`Email: ${order.users.email}`, 14, 45);
    doc.text(`Phone: ${addr.phoneNumber || "00000000000"}`, 14, 52);
  
    doc.setFontSize(14);
    doc.text("Shipping Address", 14, 68);
  
    doc.setFontSize(11);

    
    
    doc.text(`Street: ${addr.street || "N/A"}`, 14, 76);
    doc.text(`City: ${addr.city || "N/A"}`, 14, 83);
    doc.text(`State: ${addr.state || "N/A"}`, 14, 90);
    doc.text(`Country: ${addr.country || "N/A"}`, 14, 97);
    doc.text(`Postal Code: ${addr.postalCode || "N/A"}`, 14, 104);
  
    doc.setFontSize(14);
    doc.text("Order Items", 14, 120);
  
    const tableRows = order.item.map((item, index) => [
      index + 1,
      item.product.title,
      item.quantity,
      `Rs.${item.product.price}`,
      `RS.${item.quantity * item.product.price}`,
    ]);
  
    const tableBody = await prepareTableBody(order);

    autoTable(doc, {
      startY: 125,
      head: [["Product", "Color", "Size", "Qty", "Price", "Total"]],
      body: tableBody,
    });
    
    // 4. AutoTable (Products)
    // autoTable(doc, {
    //   startY: 125,
    //   head: [["Product", "Color", "Size", "Qty", "Price", "Total"]],
    //   body: order.item.map((i) => [
    //     i.product.title,
    //     i.color || "---",
    //     i.size || "---",
    //     i.quantity,
    //     "Rs." + i.product.price,
    //     "Rs." + (i.product.price * i.quantity),
    //   ]),
    // });


    // 5. Total
    doc.setFontSize(14);
    doc.text(`Grand Total: Rs.${order.total}`, 14, doc.lastAutoTable.finalY + 15);

    doc.text("Thank you for shopping with us.", 14, doc.lastAutoTable.finalY + 25);
  
    // *** OPEN IN NEW TAB ***
    window.open(doc.output("bloburl"));
  };

  const generateInvoicePDF = async (order) => {
    const doc = new jsPDF();
  
    const today = new Date().toDateString();
    
    const addressList = Array.isArray(order.address)
      ? order.address
      : [order.address];

    const addr = addressList[0] || {};

    const todaySecond = new Date();
    const todayStr = todaySecond.toDateString(); // Example: Mon Feb 17 2025

    // ----- Order Date (Firestore Timestamp Handle) -----
    const orderDate = new Date(
      order.createdAt?.seconds ? order.createdAt.seconds * 1000 : order.createdAt
    );
  
    doc.setFontSize(18);
    doc.text("ORDER INVOICE", 14, 15);
    doc.setFontSize(11);
    doc.text(`Invoice Date: ${today}`, 150, 15, { align: "right" });
  
    doc.line(10, 20, 200, 20);

    doc.setFontSize(12);
  doc.text(`Order ID: ${order._id}`, 95, 30);
  // doc.text(`Invoice Date: ${today}`, 95, 37);
  doc.text(`Status: ${order.status}`, 95, 37);
  doc.text(`Payment: ${order.paymentMode}`, 95, 44);
  
    doc.setFontSize(14);
    doc.text("Customer Details", 14, 30);
  
    doc.setFontSize(11);
    doc.text(`Name: ${order.users.name}`, 14, 38);
    doc.text(`Email: ${order.users.email}`, 14, 45);
    doc.text(`Phone: ${addr.phoneNumber || "00000000000"}`, 14, 52);
  
    doc.setFontSize(14);
    doc.text("Shipping Address", 14, 68);
  
    doc.setFontSize(11);

    
    doc.text(`Street: ${addr.street || "N/A"}`, 14, 76);
    doc.text(`City: ${addr.city || "N/A"}`, 14, 83);
    doc.text(`State: ${addr.state || "N/A"}`, 14, 90);
    doc.text(`Country: ${addr.country || "N/A"}`, 14, 97);
    doc.text(`Postal Code: ${addr.postalCode || "N/A"}`, 14, 104);
  
    doc.setFontSize(14);
    doc.text("Order Items", 14, 120);
  
    const tableRows = order.item.map((item, index) => [
      index + 1,
      item.product.title,
      item.quantity,
      `Rs.${item.product.price}`,
      `RS.${item.quantity * item.product.price}`,
    ]);
  
    
    // 4. AutoTable (Products)
    // autoTable(doc, {
    //   startY: 125,
    //   head: [["Product", "Qty", "Price", "Total"]],
    //   body: order.item.map((i) => [
    //     i.product.title,
    //     i.quantity,
    //     "Rs." + i.product.price,
    //     "Rs." + (i.product.price * i.quantity),
    //   ]),
    // });

    const tableBody = await prepareTableBody(order);

    autoTable(doc, {
      startY: 125,
      head: [["Product", "Color", "Size", "Qty", "Price", "Total"]],
      body: tableBody,
    });
  
    // ---------- TOTAL ----------
    const finalY = doc.lastAutoTable.finalY;
  
    doc.setFontSize(14);
    doc.text(`Grand Total: Rs.${order.total}`, 14, finalY + 15);
  
    // ---------- FOOTER ----------
    // doc.setFontSize(11);
    doc.text("Thank you for shopping with us.", 14, finalY + 25);
  

    // ----- File Name me bhi today date -----
    const fileNameDate = todaySecond.toISOString().split("T")[0]; // YYYY-MM-DD

    doc.save(`Order-${order._id}-${fileNameDate}.pdf`);
  };

  const order = {
    _id: "ORD123456789",
  
    user: {
      _id: "USER123",
      name: "Ali Raza",
      email: "ali@example.com",
      phone: "03001234567",
    },
  
    shipping: {
      street: "House #12, Street 5",
      city: "Faisalabad",
      state: "Punjab",
      postalCode: "38000",
      country: "Pakistan",
    },
  
    items: [
      {
        productId: "PROD001",
        title: "Nike Air Zoom Pegasus 39",
        qty: 2,
        price: 120,
        thumbnail:
          "https://images.pexels.com/photos/2529148/pexels-photo-2529148.jpeg",
      },
      {
        productId: "PROD002",
        title: "Samsung Galaxy Buds 2",
        qty: 1,
        price: 90,
        thumbnail:
          "https://images.pexels.com/photos/3394668/pexels-photo-3394668.jpeg",
      },
      {
        productId: "PROD003",
        title: "Classic Leather Wallet",
        qty: 3,
        price: 25,
        thumbnail:
          "https://images.pexels.com/photos/298863/pexels-photo-298863.jpeg",
      },
    ],
  
    total: 120 * 2 + 90 + 25 * 3, // auto calc = 305
  
    createdAt: {
      seconds: 1704825600, // Firestore timestamp demo
      nanoseconds: 0,
    },
  };
  

  return (

    <Stack justifyContent={'center'} alignItems={'center'}>

      <Stack mt={5} mb={3} component={'form'} noValidate onSubmit={handleSubmit(handleUpdateOrder)}>

        {
          orders.length?
          <TableContainer sx={{width:is1620?"95vw":"auto",overflowX:'auto'}} component={Paper} elevation={2}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Order</TableCell>
                  <TableCell align="left">Id</TableCell>
                  <TableCell align="left">Item</TableCell>
                  <TableCell align="right">Total Amount</TableCell>
                  <TableCell align="right">Shipping Address</TableCell>
                  <TableCell align="right">Payment Method</TableCell>
                  <TableCell align="right">Order Date</TableCell>
                  <TableCell align="right">Status</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>

                {
                orders.length && orders.map((order,index) => {
                  const addressList = Array.isArray(order.address)
                    ? order.address
                    : [order.address];

                  const addr = addressList[0] || {};
                  return <TableRow key={order._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>

                    <TableCell component="th" scope="row">{index}</TableCell>
                    <TableCell align="right">{order._id}</TableCell>
                    <TableCell align="right">
                      {
                        order.item.map((product) => (
                          <Stack mt={2} flexDirection={'row'} alignItems={'center'} columnGap={2}>
                            <Avatar src={product.product.thumbnail}></Avatar>
                            <Typography>{product.product.title}</Typography>
                          </Stack>
                        ))
                      }
                    </TableCell>
                    <TableCell align="right">{order.total}</TableCell>
                    <TableCell align="right">
                      <Stack>

                        {/* <Typography>{order.address[0].street}</Typography> */}
                        {/* <Typography>{order.address[0].city}</Typography>
                        <Typography>{order.address[0].state}</Typography>
                        <Typography>{order.address[0].postalCode}</Typography> */}

                        <Typography>{addr.street || "N/A"}</Typography>
                        <Typography>{addr.city || "N/A"}</Typography>
                        <Typography>{addr.state || "N/A"}</Typography>
                        <Typography>{addr.postalCode || "N/A"}</Typography>

                      </Stack>
                    </TableCell>
                    <TableCell align="right">{order.paymentMode}</TableCell>
                    <TableCell align="right">
                      {/* {new Date(order.createdAt).toDateString()} */}

                      {
                        order.createdAt
                          ? (
                            order.createdAt.toDate   // Firestore Timestamp?
                              ? order.createdAt.toDate().toDateString()
                              : new Date(order.createdAt).toDateString()  // ISO String?
                          )
                          : "N/A"
                      }
                    </TableCell>

                    {/* order status */}
                    <TableCell align="right">

                      {
                        editIndex === index ? (

                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Update status</InputLabel>
                            <Select
                              defaultValue={order.status}
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              label="Update status"
                              {...register('status', { required: 'Status is required' })}
                            >

                              {
                                editOptions.map((option) => (
                                  <MenuItem value={option}>{option}</MenuItem>
                                ))
                              }
                            </Select>
                          </FormControl>
                        ) : <Chip label={order.status} sx={getStatusColor(order.status)} />
                      }

                    </TableCell>

                    {/* actions */}
                    {/* <TableCell align="right">

                      {
                        editIndex === index ? (
                          <Button>

                            <IconButton type='submit'><CheckCircleOutlinedIcon /></IconButton>
                          </Button>
                        )
                          :
                          <IconButton onClick={() => setEditIndex(index)}><EditOutlinedIcon /></IconButton>
                      }

                    </TableCell> */}

                    {/* actions */}
                    <TableCell align="right">

                      {editIndex === index ? (
                        <Button>
                          <IconButton type="submit">
                            <CheckCircleOutlinedIcon />
                          </IconButton>
                        </Button>
                      ) : (
                        <Stack flexDirection="row" spacing={1}>

                          {/* EDIT BUTTON */}
                          <IconButton onClick={() => setEditIndex(index)}>
                            <EditOutlinedIcon />
                          </IconButton>

                          {/* VIEW PDF BUTTON */}
                          <IconButton  onClick={() => viewInvoicePDF(order)}>
                            <VisibilityIcon color="primary" />
                          </IconButton>

                          {/* DOWNLOAD PDF BUTTON */}
                          <IconButton onClick={() => generateInvoicePDF(order)}>
                            <PictureAsPdfIcon color="error" />
                          </IconButton>
                          

                           

                            

                        </Stack>
                      )}

                    </TableCell>



                  </TableRow>
                })
                }

              </TableBody>
            </Table>
          </TableContainer>
          :
          <Stack width={is480?"auto":'30rem'} justifyContent={'center'}>

            <Stack rowGap={'1rem'}>
                <Lottie animationData={noOrdersAnimation}/>
                <Typography textAlign={'center'} alignSelf={'center'} variant='h6' fontWeight={400}>There are no orders currently</Typography>
            </Stack>
              

          </Stack>  
        }
    
    </Stack>
    
    </Stack>
  )
}
